
import { defineComponent } from 'vue';
import SBtn from 'SharedComponents/ui/Button/SBtn.vue';

export default defineComponent({
  name: 'STableAction',
  components: { SBtn },
  setup(props, { slots }) {
    return { props, slots };
  },
});
